import { ReportType } from "../types";
import { get, post, put, remove } from "../helpers/apiHelper";
import { Api } from "../constants";

const API_ENDPOINTS = {
  ITEM_CONDITION: "item-condition",
  REVIEW_CATEGORY: "review-category",
}

export const createCondition = async (itemConditionName: string) => {
  const payload = {
    itemConditionName,
  };
  const url = `${Api.adminRestricted}/${API_ENDPOINTS.ITEM_CONDITION}`;

  return await post(url, payload);
};

export const getAllItemConditions = async () => {
  const url = `${Api.adminNotRestricted}${API_ENDPOINTS.ITEM_CONDITION}`;
  return await get(url);
};

export const updateCondition = async (
  itemConditionId: string,
  itemConditionName: string
) => {
  const url = `${Api.adminRestricted}/${API_ENDPOINTS.ITEM_CONDITION}/${itemConditionId}?name=${encodeURIComponent(
    itemConditionName
  )}`;
  return await put(url);
};

export const deleteCondition = async (itemConditionId: string) => {
  const url = `${Api.adminRestricted}/${API_ENDPOINTS.ITEM_CONDITION}/${itemConditionId}`;
  return await remove(url);
};

export const getAllReviewCategories = async () => {
  const url = `${Api.adminNotRestricted}${API_ENDPOINTS.REVIEW_CATEGORY}`;
  return await get(url);
};

export const createReviewCategory = async (
  reviewCategoryName: string,
  reviewType: ReportType
) => {
  const payload = {
    reviewCategoryName,
    reviewType,
  };
  const url = `${Api.adminRestricted}/${API_ENDPOINTS.REVIEW_CATEGORY}`;

  return await post(url, payload);
};

export const updateReviewCategory = async (
  reviewCategoryId: string,
  reviewCategoryName: string,
  reviewType: ReportType
) => {
  const payload = {
    reviewType,
  };
  const url = `${Api.adminRestricted}/${API_ENDPOINTS.REVIEW_CATEGORY}/${reviewCategoryId}?name=${encodeURIComponent(
    reviewCategoryName
  )}`;

  return await put(url, payload);
};

export const deleteReviewCategory = async (reviewCategoryId: string) => {
  const url = `${Api.adminRestricted}/${API_ENDPOINTS.REVIEW_CATEGORY}/${reviewCategoryId}`;
  return await remove(url);
};
